import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

interface PropTypes {
  mainText: string;
  prospectImage: string;
}

export function MainTextAndImage(props: PropTypes) {
  return (
    <div className='row justify-content-center text-center'>
      <h1 className='mb-4'>{props.mainText}</h1>
      <div className='row my-2 py-1 justify-content-center'>
        <img
          src={props.prospectImage}
          alt='Screenloop'
          className={classNames(styles['main-image'])}
        />
      </div>
    </div>
  );
}
